import React from "react";
import { TrendingUp, Users, Tag, Settings } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const services = [{
  title: "Excavate",
  description: "Deploy your field-kit to extract high-fidelity soil profiles.",
  icon: TrendingUp
}, {
  title: "Identify",
  description: "Analyze mineral composition using real-world ISRIC data.",
  icon: Users
}, {
  title: "Catalog",
  description: "Build your global collection of 195 unique earth profiles.",
  icon: Tag
}, {
  title: "Discover",
  description: "Unlock the hidden scientific mysteries of the deep earth.",
  icon: Settings
}];
export default function PromotionalServices() {
  return <section data-section-id="242647" id="how-it-works" className="bg-background text-foreground py-24">
      <div className="page-container">
        <div className="mb-16 text-center">
          <h2 className="font-serif text-3xl font-bold tracking-widest text-primary uppercase md:text-4xl lg:text-5xl">
            How It Works
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 bg-gradient-to-r from-transparent via-primary to-transparent"></div>
        </div>
        
        {}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          const stepNumber = `0${i + 1}`;
          return <Card key={i} data-index={i} className="group border border-primary/20 bg-card/40 backdrop-blur-md text-center shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(196,138,58,0.3)] rounded-sm">
                <CardHeader className="pb-4">
                  <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-secondary/10 text-secondary transition-transform duration-300 group-hover:scale-110 group-hover:text-primary">
                    <span className="absolute -top-2 -right-2 font-mono text-sm font-bold text-primary/60">{stepNumber}</span>
                    <Icon className="h-10 w-10" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl font-bold text-foreground tracking-wider uppercase">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-default text-base text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        {}
        <div className="mx-auto mt-20 max-w-3xl text-center">
          <p className="font-serif text-xl italic text-primary md:text-2xl tracking-widest uppercase">
            «Four Steps. Endless Discovery.»
          </p>
          <p className="mt-6 font-default font-semibold text-secondary tracking-widest">
            — TERRIGMA EXPEDITION LOG
          </p>
        </div>

        {}
        <div className="mt-24 flex flex-col overflow-hidden rounded-sm bg-card border border-primary/20 text-foreground shadow-2xl md:flex-row">
          <div className="flex flex-1 flex-col justify-center p-10 md:p-16 lg:p-20">
            <h3 className="font-serif text-3xl font-bold leading-tight text-primary md:text-4xl lg:text-5xl">
              DIG THE WORLD.<br />
              COLLECT THE<br />
              EARTH.
            </h3>
            <p className="mt-6 max-w-md text-lg text-muted-foreground font-default">
              Powered by real FAO and ISRIC earth science data for a truly global exploration.
            </p>
          </div>
          <div className="relative min-h-[300px] flex-1 md:min-h-full">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/soil_exploration_gameplay.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/soil_exploration_gameplay.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/soil_exploration_gameplay.png-wvc-sizes" alt="Scientific soil profile excavation in Terrigma" className="absolute inset-0 h-full w-full object-cover opacity-60 mix-blend-screen" loading="lazy" />
            {}
            <div className="absolute inset-0 bg-gradient-to-r from-card to-transparent md:w-1/3"></div>
          </div>
        </div>

      </div>
    </section>;
}